import { WorkspaceDTO } from "./redux/store/workspace";

export const Dummy_tenancyList = [
  {
    tenancyCode: "MTECOCOMMON00001",
    tenancyName: "My Space",
    dsdCode: "MTECOCOMMON00001",
    product: "WRAPSODY_ECO",
    userId: null,
    alias: "My Space",
    tenancyStatus: "RUNNING",
    createUserId: "eco_admin",
    masterUserId: "eco_admin",
    createdTime: 0,
    updatedTime: 0,
    currentInternalUserCount: 0,
    currentExternalUserCount: 0,
    maxInternalUserCount: 0,
    maxExternalUserCount: 0,
    paymentCode: "ECO_DEFAULT_PAYMENT",
    paymentInfo: {
      paymentCode: "ECO_DEFAULT_PAYMENT",
      payUserId: "eco_admin",
      planCode: "DEFAULT_ECO_PLAN",
      serviceStartTime: 0,
      serviceEndTime: 0,
      maxInternalUserCount: 0,
      maxExternalUserCount: 0,
      payTerm: 0,
      payDay: 0,
      payDate: 0,
      startDate: 0,
      additionalStorage: 0,
      storagePerUser: 5,
      price: 0,
    },
    myDefaultTenancy: false,
    userStatus: 1,
    allowIpAccess: true,
    tenancyUsageSize: 0,
  },
  {
    tenancyCode: "MTECOFED00000111",
    tenancyName: "ecocash",
    dsdCode: "MTECOFED00000111",
    product: "WRAPSODY_ECO",
    userId: null,
    alias: "ecocash",
    tenancyStatus: "RUNNING",
    createUserId: "dongdev@fasoo.com",
    masterUserId: "dongdev@fasoo.com",
    createdTime: 1727670041004,
    updatedTime: 1727670043083,
    currentInternalUserCount: 0,
    currentExternalUserCount: 0,
    maxInternalUserCount: 0,
    maxExternalUserCount: 0,
    paymentCode: "19742b0f641f492699d9fe4698957fd9",
    paymentInfo: {
      paymentCode: "19742b0f641f492699d9fe4698957fd9",
      payUserId: "dongdev@fasoo.com",
      planCode: "c82a7e1734104108b60d94990c6267bb",
      serviceStartTime: 1727669998455,
      serviceEndTime: 0,
      maxInternalUserCount: 10,
      maxExternalUserCount: 100,
      payTerm: 365,
      payDay: 30,
      payDate: 20240930,
      startDate: 20241001,
      additionalStorage: 0,
      storagePerUser: 50,
      price: 0,
    },
    myDefaultTenancy: true,
    userStatus: 1,
    allowIpAccess: true,
    tenancyUsageSize: 623154000,
  },
] as WorkspaceDTO[];
